import { MinutaDto } from '../../api/dto/MinutaDto';
import { Minuta } from '../../modelo';

export class MapeadorMinuta {

    public toMinuta(minutaDto: MinutaDto): Partial<Minuta> {
        return minutaDto;
    }
}
